var Client = (function () {
    var httpMethods = {
        get: 'GET',
        post: 'POST',
        put: 'PUT',
        delete: 'DELETE'
    }


    function Request(url, method, data, success, failed) {
        var options = {
            url: url,
            method: method,
            contentType: 'application/json'
        };

        if (typeof data != 'undefined')
            options['data'] = data;

        if (typeof success == 'function')
            options['success'] = success;
        else
            options['success'] = function (d) { Engage.Notify.Success("Operation was successful") }

        if (typeof failed == 'function')
            options['error'] = failed;
        else
            options['error'] = function () { Engage.Notify.Error("An error occured.") }

        $.ajax(options);
    }

    return {
        /**
        *   Make a http get request
        *   @param {string} url The url to make the request to.
        *   @param {object} success The method to call when the request is a success.
        *   @param {object} failed The method to call when the request fails.
        */
        Get: function (url, data, success, failed) {
            Request(url, httpMethods.get, data, success, failed)
        },
        GetData: function (url, data, success, failed) {
            Request(url, httpMethods.get, data, success, failed)
        },
        /**
        *   Make a http post request
        *   @param {string} url The url to make the request to.
        *   @param {object} data The data object to post with the request.
        *   @param {object} success The method to call when the request is a success.
        *   @param {object} failed The method to call when the request fails.
        */
        Post: function (url, data, success, failed) {
            Request(url, httpMethods.post, data, success, failed)
        },
        Put: function (url, data, success, failed) {
            Request(url, httpMethods.put, data, success, failed)
        },
        Delete: function (url, success, failed) {
            Request(url, httpMethods.delete, null, success, failed)
        }
    }
}
)();